export function getRemoteConfig() {
    const isProd = ['beta', 'staging', 'production'].includes(process.env.NODE_ENV);
    const apiName = isProd ? 'prod' : 'test';

    // portm 修改地址：https://horn.sankuai.com/files/edit/1731?file-edit.env=2
    return `https://portal-portm.meituan.com/horn/v1/modules/renxiao/${apiName}`;
}
export async function getHornData({ self, prop, defaultValue = [] }) {
    const url = getRemoteConfig();

    const result = await self.$get(url).then((data) => (data ? data[prop] : defaultValue)).catch(() => defaultValue);
    return result;
}
